module.exports = __webpack_public_path__ + "static/media/20.6e92b76c.png";